import { useState, useLayoutEffect } from "react";
import updateUrlParams from "../helpers/url-params";

const useToggle = () => {
    const [isOpen, setIsOpen] = useState(false);

    useLayoutEffect(() => {
        if (typeof window !== 'undefined') {
            const params = new URLSearchParams(window.location.search);
            setIsOpen(params.get('utg') === '1');
        }
    }, []);

    const toggle = () => {
        setIsOpen((prevState) => {
            if (typeof window !== "undefined") {
                const newParams = { utg: prevState ? null : "1" };
                updateUrlParams(newParams);
            }
            return !prevState;
        });
    };

    return { isOpen, toggle };
};

export default useToggle;
